// services/mocks/event.mock.js
const mockEvents = [
    {
        id: 1,
        name: 'Onboard Festival 2026',
        description: `<b>SOBRE</b>
                <p>Prepare-se para subir a bordo do <b>Energia Onboard</b>, o cruzeiro temático com o melhor da música anos 80, 90 e 2000.
                    A bordo, você encontrará uma programação de shows eletrizantes com artistas nacionais e internacionais e festas com vários os DJ’s comandando o melhor da música flashback. 
                    Com dois palcos monumentais e uma variedade de atividades interativas, este navio é o destino perfeito para quem deseja viver e eternizar momentos incríveis.
                    Viva essa experiência, viva essa nova energia!
                </p>
                <b>LINE-UP</b>
                <p>Jon Secada<br>
                    Paulo Ricardo<br>
                    Double You<br>
                    C&C Music Factory<br>
                    Gigantes dos anos 80<br>
                    Sandra Sá<br>
                    Nicki French<br>
                    Turbo B – From Snap<br>
                    + DJ’s tocando o melhor do flashback
                </p>
                <b>≋≋ CABINES ≋≋</b>
                <p>CABINE INTERNA - Praticidade em estilo clássico, para uma experiência com melhor custo-benefício.<br>
                    CABINE COM JANELA – O encanto dos primeiros raios de sol. Elegante e confortável, bem iluminada, com janela com vista para o mar.<br>
                    CABINE COM VARANDA – O luxo de uma sacada privativa, para uma experiência emocionante de proximidade com o mar.<br>
                    SUÍTE PREMIUM ALL INCLUSIVE - O luxo de uma sacada privativa, espaçosa e com uma localização exclusiva, para uma experiência emocionante de contato próximo com o mar. Além de todo o conforto e luxo, aproveite uma experiência All Inclusive com o pacote de bebidas<br>
                    *Pacote de bebidas premium incluso na compra da cabine.
                </p>
                <b>REGRAS DE COMPRA</b>
                <p>Classificação etária do evento: Livre para todas as idades</p>
                <b>MENORES DE IDADE</b>
                <p>Menores de Idade. A idade mínima para viajar desacompanhado é 18 (dezoito) anos, que devem estar completos na data do embarque.
                    Não será permitido o embarque de menores de 18 (dezoito) anos, mesmo que estejam emancipados, quando desacompanhados de, ao menos,
                    um dos pais ou de seu responsável legal ou de outro adulto que válida e legalmente assuma todas as responsabilidades sobre ele,
                    sendo certo que menores deverão ser acomodados na mesma cabine que seu responsável.  
                    Também não será permitido o embarque de crianças que, na data do embarque, tenham idade inferior a 6 (seis) meses.
                </p>`,
        thumb_image: '/mock-images/thumb-onboard-festival.jpg', // Endereço CDN da imagem no futuro...
        cover_image: '/mock-images/background-onboard-energia.jpg',
        date_begin: '2026-12-25',
        date_end: '2026-12-30',
        location: 'Porto de Santos, Brasil',
        onboard: {
            date: '2026-09-25',
            location: 'Porto de Santos, Brasil'
        },
        unboard: {
            date: '2026-09-25',
            location: 'Porto de Santos, Brasil' 
        },
    },
    {
        id: 2,
        name: 'Energia Festival 2026',
        description: `<b>SOBRE</b>
                <p>3 noites a bordo de um luxuoso navio com uma programação completa de shows com grandes artistas e festas incríveis. O Onboard Festival
                é a viagem perfeita para escapar da rotina e esquecer de toda preocupação do dia-a-dia. 
                </p>
                <b>UM LINE-UP DE RESPEITO</b>
                <p>Jorge e Mateus<br>
                    Zé Neto<br>
                    Cristiano<br>
                    Menos é Mais<br>
                    Murilo Huff<br>
                    Henry Freitas<br>
                    Traia Veia<br>
                    Yasmin Santos<br>
                    Thiago e Samuel <br>
                    + outros
                </p>
                <b>≋≋ CABINES ≋≋</b>
                <p>CABINE INTERNA - Praticidade em estilo clássico, para uma experiência com melhor custo-benefício.<br>
                    CABINE COM JANELA – O encanto dos primeiros raios de sol. Elegante e confortável, bem iluminada, com janela com vista para o mar.<br>
                    CABINE COM VARANDA – O luxo de uma sacada privativa, para uma experiência emocionante de proximidade com o mar.<br>
                    SUÍTE PREMIUM ALL INCLUSIVE - O luxo de uma sacada privativa, espaçosa e com uma localização exclusiva, para uma experiência emocionante de contato próximo com o mar. Além de todo o conforto e luxo, aproveite uma experiência All Inclusive com o pacote de bebidas<br>
                    *Pacote de bebidas premium incluso na compra da cabine.
                </p>
                <b>REGRAS DE COMPRA</b>
                <p>Classificação etária do evento: Livre para todas as idades</p>
                <b>MENORES DE IDADE</b>
                <p>Menores de Idade. A idade mínima para viajar desacompanhado é 18 (dezoito) anos, que devem estar completos na data do embarque.
                    Não será permitido o embarque de menores de 18 (dezoito) anos, mesmo que estejam emancipados, quando desacompanhados de, ao menos,
                    um dos pais ou de seu responsável legal ou de outro adulto que válida e legalmente assuma todas as responsabilidades sobre ele,
                    sendo certo que menores deverão ser acomodados na mesma cabine que seu responsável.  
                    Também não será permitido o embarque de crianças que, na data do embarque, tenham idade inferior a 6 (seis) meses.
                </p>`,
        thumb_image: '/mock-images/thumb-onboard-energia.jpg', // Endereço CDN da imagem no futuro...
        cover_image: '/mock-images/background-onboard-energia.jpg',
        date_begin: '2026-09-25',
        date_end: '2026-09-30',
        location: 'Porto de Santos, Brasil',
        onboard: {
            date: '2026-09-25',
            location: 'Porto de Santos, Brasil'
        },
        unboard: {
            date: '2026-09-25',
            location: 'Porto de Santos, Brasil' 
        }
    },
    {
        id: 3,
        name: 'Palestra com Paulo Vieira',
        description: `<b>SOBRE</b>
                <p>Autor best-seller e fundador da Febracis, participou dessa experiência em alto-mar,
                compartilhando sua metodologia de sucesso e inspirando transformações com palestras impactantes.</p>`,
        thumb_image: '/mock-images/thumb-onboard-paulo-vieira.jpg', // Endereço CDN da imagem no futuro...
        cover_image: '/mock-images/background-palestra-paulo-vieira.jpg',
        date_begin: '2026-09-25',
        location: 'São Paulo, Brasil',
    },
    {
        id: 4,
        name: 'Buteco em Alto Mar',
        description: `<b>SOBRE</b>
                <p>🍺 O Maior Buteco do Mundo agora em alto mar!
                    🚢 Você vai viver uma experiência única do nosso festival!</p>`,
        thumb_image: '/mock-images/thumb-onboard-gustavo-lima.jpg', // Endereço CDN da imagem no futuro...
        cover_image: '/mock-images/background-generico-onboard.jpg',
        date_begin: '2026-10-25',
        location: 'Goiania, Brasil',
    },
    {
        id: 5,
        name: 'Palestra com Tania Zambon',
        description: `<b>SOBRE</b>
                <p>Levou ao Cruzeiro palestras sobre liderança e desenvolvimento humano, inspirando os participantes a desbloquearem seu potencial e alcançarem novos resultados.</p>`,
        thumb_image: '/mock-images/thumb-onboard-tania.jpg', // Endereço CDN da imagem no futuro...
        cover_image: '/mock-images/background-generico-onboard.jpg',
        date_begin: '2026-11-25',
        location: 'Rio de Janeiro, Brasil',
    },
];

const mockEventsProducts = [
    {
        id: 1,
        event_id: 1,
        name: 'Cabine Interna',
        description: `<p>Praticidade em estilo clássico para uma experiência com maior custo-benefício.</p>
                <p>Elegantes e confortáveis, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-interna.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 1,
                name: 'Cabine Interna | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 2,
                name: 'Cabine Interna | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 3,
                name: 'Cabine Interna | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 4,
                name: 'Cabine Interna | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 2,
        event_id: 1,
        name: 'Cabine com Janela',
        description: `<p>O encanto dos primeiros raios de sol pela manhã com as cores mais lindas do oceano.</p>
                    <p>Elegante e confortável, bem iluminada e com janela com vista para o mar, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-com-janela.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 5,
                name: 'Cabine com Janela | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 6,
                name: 'Cabine com Janela | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 7,
                name: 'Cabine com Janela | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 8,
                name: 'Cabine com Janela | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 3,
        event_id: 1,
        name: 'Cabine com Varanda',
        description: `<p>O luxo de uma sacada privativa, para uma experiência emocionante de proximidade com o mar.</p>
                    <p>Elegante e confortável, conta com grande varanda privativa, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-com-varanda.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 9,
                name: 'Cabine com Varanda | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 10,
                name: 'Cabine com Varanda | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 11,
                name: 'Cabine com Varanda | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 12,
                name: 'Cabine com Varanda | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 4,
        event_id: 1,
        name: 'Suíte Premium',
        description: `<p>A união do luxo e exclusividade com uma experiência All Inclusive. Conta com embarque prioritário, localização exclusiva, restaurante exclusivo para almoço e jantar, espaço reservado nos shows e Pacote de Bebidas Premium.</p>
                    <p>Elegante e confortável, conta com grande varanda privativa, com TV, ar-condicionado, banheiro privativo com banheira e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-suite-premium.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 13,
                name: 'Suíte Premium | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 14,
                name: 'Suíte Premium | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 15,
                name: 'Suíte Premium | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 16,
                name: 'Suíte Premium | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 5,
        event_id: 2,
        name: 'Cabine Interna',
        description: `<p>Praticidade em estilo clássico para uma experiência com maior custo-benefício.</p>
                <p>Elegantes e confortáveis, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-interna.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 1,
                name: 'Cabine Interna | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 2,
                name: 'Cabine Interna | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 3,
                name: 'Cabine Interna | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 4,
                name: 'Cabine Interna | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 6,
        event_id: 2,
        name: 'Cabine com Janela',
        description: `<p>O encanto dos primeiros raios de sol pela manhã com as cores mais lindas do oceano.</p>
                    <p>Elegante e confortável, bem iluminada e com janela com vista para o mar, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-com-janela.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 5,
                name: 'Cabine com Janela | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 6,
                name: 'Cabine com Janela | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 7,
                name: 'Cabine com Janela | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 8,
                name: 'Cabine com Janela | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 7,
        event_id: 2,
        name: 'Cabine com Varanda',
        description: `<p>O luxo de uma sacada privativa, para uma experiência emocionante de proximidade com o mar.</p>
                    <p>Elegante e confortável, conta com grande varanda privativa, com TV, ar-condicionado, banheiro privativo e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-cabine-com-varanda.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 9,
                name: 'Cabine com Varanda | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 10,
                name: 'Cabine com Varanda | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 11,
                name: 'Cabine com Varanda | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 12,
                name: 'Cabine com Varanda | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    },
    {
        id: 8,
        event_id: 2,
        name: 'Suíte Premium',
        description: `<p>A união do luxo e exclusividade com uma experiência All Inclusive. Conta com embarque prioritário, localização exclusiva, restaurante exclusivo para almoço e jantar, espaço reservado nos shows e Pacote de Bebidas Premium.</p>
                    <p>Elegante e confortável, conta com grande varanda privativa, com TV, ar-condicionado, banheiro privativo com banheira e cofre.</p>
                    <a href="/">Saiba mais</a>`,
        thumb_image: '/mock-images/thumb-suite-premium.jpg', // Endereço CDN da imagem no futuro...
        product_items: [
            {
                id: 13,
                name: 'Suíte Premium | Single | 1° Lote',
                price: 2000.00,
                quantity: 0,
            },
            {
                id: 14,
                name: 'Suíte Premium | Dupla | 1° Lote',
                price: 2500.00,
                quantity: 0,
            },
            {
                id: 15,
                name: 'Suíte Premium | Tripla | 1° Lote',
                price: 3000.00,
                quantity: 0,
            },
            {
                id: 16,
                name: 'Suíte Premium | Quadrupla | 1° Lote',
                price: 3500.00,
                quantity: 0,
            }
        ]
    }
];

export { mockEvents, mockEventsProducts };